import React from 'react';
import { ChartBarIcon, DocumentTextIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const Dashboard: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Dashboard</h1>
      <p className="section-description">
        The central hub for monitoring your application's key metrics and recent activities.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <ChartBarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Dashboard Stats</h3>
              <p className="feature-description">
                Overview of key metrics and statistics:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Real-time system statistics</li>
                <li>Key performance indicators</li>
                <li>Quick insights into system health</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChartBarIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Resource Type Chart</h3>
              <p className="feature-description">
                Visual representation of resource distribution:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Resource type breakdown</li>
                <li>Distribution analysis</li>
                <li>Resource categorization overview</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentTextIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Recent Pages</h3>
              <p className="feature-description">
                Latest page updates and activities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Recently created or modified pages</li>
                <li>Quick access to page content</li>
                <li>Page activity tracking</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Recent Team Members</h3>
              <p className="feature-description">
                Latest team member activities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>New team member additions</li>
                <li>Recent team member updates</li>
                <li>Team activity overview</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Regularly monitor dashboard stats for system health</li>
            <li>Use the resource type chart to understand content distribution</li>
            <li>Keep track of recent page updates for content management</li>
            <li>Monitor team member activities for better collaboration</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 